import React from "react";

function InputField ({input, control, register}: any) {
  let jsxMarkup = null;

  jsxMarkup = (
    <input
      className="input-field border"
      type={input?.type || 'text'} 
      value={input?.value}
      placeholder={input?.placeholder || ''}
      {...register(input?.name || '', { required: input?.required })} 
    />
  )

  return jsxMarkup;
}

export default InputField;
